import { render, staticRenderFns } from "./csvreceivables.vue?vue&type=template&id=65268df1&scoped=true&"
import script from "./csvreceivables.vue?vue&type=script&lang=js&"
export * from "./csvreceivables.vue?vue&type=script&lang=js&"
import style0 from "./csvreceivables.vue?vue&type=style&index=0&id=65268df1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65268df1",
  null
  
)

export default component.exports